import {useQuery} from "@tanstack/react-query";
import {adminsListSuperUrl} from "../../constants/api/endpoints";
import {useAxios} from "../../hooks/axios/useAxios";

interface AdminsListProps {
  search_term?: string,
  sorting_type?: string,
  hide_inactive?: boolean,
}

export const useQueryAdmins = (params: AdminsListProps) => {
  const {
    search_term,
    sorting_type,
    hide_inactive
  } = params;

  const axios = useAxios();

  const handleRequest = () => {
    return axios.get(adminsListSuperUrl,
      {params: {
          search_term,
          sorting_type,
          hide_inactive
        }})
      .then(response => response?.data.cpl_admins ?? response);
  }

  return useQuery({
    queryKey: ['admins-list-super', params],
    queryFn: handleRequest,
  })
}